export default __webpack_public_path__ + "static/media/verifiedIconGreen.dfa88485.svg";